import { type Line } from '~/apps/product-plus/components/BettingInsights/types';

export const formatLine = (line: Line) => {
  const signs = {
    Over: 'O ',
    Under: 'U ',
  };

  if (line.sign === '-' || line.sign === '+') {
    return undefined;
  }

  const lineSign = signs[line.sign as keyof typeof signs] || line.sign;

  return `${lineSign}${line.absolute}`;
};
